import { FC, useState } from 'react';
import { useNavigate } from "react-router-dom";
import css from './index.module.css';
import AddPopupProduct from '@components/addProductPopup';

interface MiniProductInt {
    id: number;
    product?: any;
    title: string;
    price: number; 
    image: string;
    unit: 'ШТ' | 'КГ';
    quantity: number;
}

const MiniProduct: FC<MiniProductInt> = ({ id, title, price, image, unit = 'ШТ', quantity = 0 }) => {
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>();

    const selectProduct = () => {
        setSelectedProduct({ id, title, price, image, unit, quantity });
        setShowPopup(true);
    };

    const goProduct = () => {
        navigate(`/webapp/product/${id}`);
    };

    return (
    <>
        <AddPopupProduct showPopup={showPopup} setShowPopup={setShowPopup} product={selectedProduct} />
        <div className={css.miniProduct} onClick={goProduct}>
            <img src={image ? image : '/assets/images/noImage.jpg'} alt={title} className={css.productImage} />
            <div className={css.textInfo}>
                <div>
                    <a style={{ fontWeight: 600, fontSize: 20, color: "#0077FF" }}>{price} ₽ / {unit}</a>
                    <h2 style={{ fontWeight: 500, fontSize: 17 }}>{title}</h2>
                </div>

                <button className={css.addToCart} onClick={(e) => { e.stopPropagation(); selectProduct(); }}>В корзину</button>
            </div>
        </div>
    </>
    );
};

export default MiniProduct;